<template>
  <div>
    <div class="uk-grid-medium" uk-grid>
      <div class="uk-width-5-5">
        <app-bread-crumb :list="breadCrumbList"/>

        <template v-if="errorMessages">
          <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p style="color: red">
              <i class="uil-exclamation-triangle"></i> {{ error }}
            </p>
          </div>
        </template>
        <div v-if="successMessage" class="uk-alert-success" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: green">
            <i class="uil-exclamation-triangle"></i> {{ successMessage }}
          </p>
        </div>

        <div uk-grid="masonry: pack">

          <exam-properties-menu ref="examMenuRef"
                                :initial-data="examMenuData"
                                :is-pre-post-active="isPrePostActive"
                                menu-id="exam-properties"/>

          <div class="card uk-width-3-4@m position-relative p-0">
            <div v-if="loading" class="loading-bar">
              <div class="text-info" uk-spinner="ratio: 4"></div>
            </div>
            <div class="card-body">
              <div class="uk-flex uk-flex-middle uk-flex-between">
                <h4 class="m-0"><i class="uil-pen"></i> {{ pageTitle }}</h4>
                <button :uk-toggle="'#exam-properties'" class="uk-button uk-button-default uk-margin-small-right"
                        type="button"><i class="uil-cog"/> {{ $t('exam.exam_features') }}
                </button>
              </div>
              <hr/>
              <div class="row">
                <div class="col-xl-12 m-auto">
                  <form action="">

                    <!-- Excel / Anzera sekmeleri YALNIZCA ekleme modunda.
                         Duzenlemede mevcut sorular yuklenir; ice aktarma
                         onlarin uzerine yazacagi icin anlamsiz. -->
                    <ul v-if="!isEditMode" id="userAddOptions" class="uk-tab page-tab"
                        uk-switcher="animation: uk-animation-fade">
                      <li v-for="(tab, index) in tabs" :key="tab.id">
                        <a :id="tab.id" href="#" @click.prevent="setActiveTab(index)">
                          <h5><i :class="tab.icon"/> {{ tab.label }}</h5>
                        </a>
                      </li>
                    </ul>

                    <ul v-if="!isEditMode" class="uk-switcher">
                      <li>
                        <questions-demo ref="myEvent" :importedExam="importedExam"
                                        :questions="[]" action="create" model-type="Exam"/>
                      </li>
                      <li>
                        <survey-from-excel-uploader :sample-excel-endpoint="'/api/exam/exam-download-sample-excel'"
                                                    @imported="handleImportedExcelData"/>
                      </li>
                      <li>
                        <anzera-power-chat @handleQuestions="handleAnzeraData" @onCancelled="setActiveTab(0)"/>
                      </li>
                    </ul>
                    <div v-if="!isEditMode" class="d-flex justify-content-end  align-items-center">
                      <toggle-button v-model="is_default"
                                     :labels="{ checked: $t('exam.default'), unchecked: $t('exam.not_default') }"
                                     :sync="true" :width="120" color="#ae71ff"/>
                    </div>

                    <!-- Duzenleme: tek gorunum + pre/post kilidi.
                         toggle-button BILEREK kilit kapsayicisinin ICINDE —
                         Edit-demo.vue'daki yerlesim aynen korundu. -->
                    <div v-if="isEditMode" :class="{ 'prepost-disable-all-questions': isPrePostActive }">
                      <div v-if="isPrePostActive" class="prepost-message-disable-text">
                        {{ $t('general.prepost_disable_message') }}
                      </div>
                      <questions-demo ref="myEvent" :importedExam="questions"
                                      :questions="[]" action="create" model-type="Exam"/>

                      <div class="d-flex justify-content-end  align-items-center">
                        <toggle-button v-model="is_default"
                                       :labels="{ checked: $t('exam.default'), unchecked: $t('exam.not_default') }"
                                       :sync="true" :width="120" color="#ae71ff"/>
                      </div>
                    </div>

                    <div class="uk-card-footer float-right pb-0 pr-0">
                      <button class="uk-button uk-button-primary small" type="button" @click="saveForm">
                        <i class="icon-feather-arrow-right"></i> {{ $t("general.save") }}
                      </button>
                      <button v-if="!isEditMode" class="uk-button uk-button-primary small ml-2" type="button"
                              @click="saveForm('assign_page')">
                        <i class="uil-location-arrow"></i> {{ $t("general.save_and_assign") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";

import module, {
  BASE_URL,
  CREATE_ITEM,
  ERROR,
  GET_ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM,
} from "@/core/services/store/exam.module";
import AppBreadCrumb from "@/view/components/breadCrumb/AppBreadCrumb.vue";
import QuestionsDemo from "@/view/components/question/Questions-demo.vue";
import ExamPropertiesMenu from "@/view/company/Exam/components/ExamPropertiesMenu.vue";
import AnzeraPowerChat from "@/view/components/anzera-power/anzera-power-chat/anzera-power-chat.vue";
import SurveyFromExcelUploader from "@/view/components/uploader/SurveyFromExcelUploader.vue";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "AddEditExamDemo",
  components: {
    AppBreadCrumb,
    QuestionsDemo,
    ExamPropertiesMenu,
    AnzeraPowerChat,
    SurveyFromExcelUploader,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, module);
  },
  data() {
    return {
      errorMessages: [],
      successMessage: null,
      show_result: true,
      duration: 20,
      is_default: false,
      questions: [],
      is_loading: false,
      file: null,
      file_value: null,
      importedExam: null,
      fileInfo: {
        name: "",
        count: 0,
        file: null,
      },
      is_added: false,
      examMenuData: {},
      // Duzenlemede yuklenen sinav
      exam: [],
      // pre/post sinavlarda sorular degistirilemez
      isPrePostActive: false,
      activeTab: 0, // Dynamically track the active tab index
      tabs: [
        { id: 'add_from_manuel', label: this.$t('exam.questions'), icon: 'uil-list-ul' },
        { id: 'add_from_excel', label: this.$t('users.add_to_excel'), icon: 'uil-table' },
        //{ id: 'add_from_quizpool', label: 'Soru Havuzundan Ekle', icon: 'uil-cloud-database-tree' },
        { id: 'add_from_anzerapower', label: this.$t('general.create_anzera'), icon: 'uil-robot' }
      ]
    };
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    pageTitle() {
      return this.isEditMode ? this.$t("exam.edit") : this.$t("exam.add");
    },
    // Eskiden `data`da sabitti ve Edit-demo'da da "exam.add" yaziyordu
    // (kopyala-yapistir hatasi); computed olunca moda ve dile duyarli.
    breadCrumbList() {
      return [{ name: this.$t("exam.exams") }, { name: this.pageTitle }];
    },
    loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[_MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    success: {
      get() {
        return store.getters[_MODULE_NAME + "/" + SUCCESS];
      },
      set(value) {
      },
    },
  },
  methods: {
    handleImportedExcelData(datax) {
      this.importedExam = datax
          .filter(data => data) // skip empty objects if comes from excell
          .map((data, examIndex) => {
            const questionText = data[0]; // Soru metni - ilk şık

            // Boş olmayan şıkları al
            const rawOptions = data.slice(1)
                .filter(option => option !== null && option !== '' && option !== undefined);

            // Son şık cevap şıkkı olacak
            const rawAnswer = rawOptions.pop();

            // Şık sayısına göre harf seçenekleri oluştur 3 şık ise A,B,C üretilecek
            const answerLetters = Array.from({ length: rawOptions.length }, (_, i) =>
                String.fromCharCode(65 + i) // 65 = 'A' ASCII kodu
            );

            // Seçenekleri oluştur
            const options = rawOptions.map((option, optionIndex) => ({
              id: optionIndex,
              name: option,
              is_correct: false,
              media: ''
            }));

            // Doğru cevabı bul
            const answerLetter = rawAnswer?.toString().toUpperCase().trim();
            const correctAnswerIndex = answerLetters.indexOf(answerLetter);

            if (correctAnswerIndex !== -1 && options[correctAnswerIndex]) {
              options[correctAnswerIndex].is_correct = true;
            } else {
              // Eğer doğru cevap unutulduysa vs , ilk şıkkı işaretle
              if (options.length > 0) {
                options[0].is_correct = true;
              }
            }

            return this.createQuestionObject({
              id: examIndex,
              text: questionText,
              options
            });
          });

      this.setActiveTab(0)
    },
    handleAnzeraData({ data }) {
      this.importedExam = data.map((item, index) => {
        if (item.type === 'text') {
          return this.createQuestionObject({
            id: index,
            text: item.question,
            options: Object.entries(item.options).map(([key, value], optionIndex) => ({
              id: optionIndex,
              name: value,
              is_correct: key === item.correct_answer,
              media: ''
            }))
          });
        } else if (item.type === 'image') {
          return this.createQuestionObject({
            id: index,
            media: item.image_url,
            preview: item.image_url,
            text: item.title || '',
            options: [{ id: index, name: '', is_correct: false, media: '' }]
          });
        } else if (item.type === 'file') {
          return this.createQuestionObject({
            id: index,
            text: item.question || '',
            options: Object.entries(item.options).map(([key, value], optionIndex) => ({
              id: optionIndex,
              name: value,
              is_correct: key === item.correct_answer,
              media: ''
            }))
          });
        }
      });
      this.setActiveTab(0);
    },

    createQuestionObject({ id, type = 1, text = '', media = '', options = [] }) {
      return {
        id,
        type, // coktan secmeli soruyu temsil ediyor default=1
        text,
        media,
        options,
        preview: null,
        audioPreview: null,
        videoPreview: null,
        previewReply: [],
        questionScore: null,
        questionDuration: null
      };
    },
    saveForm(process_type) {
      let self = this;

      let myQuestions = self.validateExamData();
      if (!myQuestions) return false;

      let formData = self.buildFormData(myQuestions);

      if (self.isEditMode) {
        // Basari/hata yonetimi `success` / `error` watcher'larinda
        store.dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
          url: BASE_URL + "/" + self.$route.params.id,
          contents: formData,
        });
        return;
      }

      store.dispatch(MODULE_NAME + "/" + CREATE_ITEM, {
        url: BASE_URL,
        contents: formData,
      }).then((response) => {
        // Store'un catch'i hatayi yutup `undefined` ile resolve ediyor
        // (exam.module.js:127). Bu guard olmadan:
        //  - assign_page dalinda `response.content_id` TypeError atiyordu
        //  - diger dalda basarisiz kayit "basariyla olusturuldu" gosterip
        //    listeye yonlendiriyordu
        // Hata mesaji `error` watcher'i uzerinden gorunur.
        if (!response) return;

        if (process_type === 'assign_page') {
          this.$router.push({
            name: "company.assignments.add",
            params: { id: response.content_id, title: response.name, name: this.$t('exam.exam') }
          });
        } else {
          this.successMessage = this.$t("general.successfully_created");
          this.$router.push({ name: "company.exams.list" });
        }
      });
    },
    validateExamData() {
      let self = this;

      self.examMenuData = { ...self.$refs.examMenuRef.handleNewExamMenu() }
      let myQuestions = self.$refs.myEvent.handleNewQuestions();

      // DOM dan pre-post disable class'larına mudahale edilirse , buradan engelle
      /* if (this.isPrePostActive) {
           self.errorMessages.push(this.$t("general.pre_post_exam_update_warning"));
           self.scrollToTop();
           return false;
       }*/

      // Soru yoksa hata
      if (myQuestions.length === 0) {
        self.errorMessages.push(this.$t("validation.required_field").replace(":NAME", self.$t("exam.question")));
        self.scrollToTop();
        return false;
      }

      // Sınav adı kontrolü
      if (!self.examMenuData.exam_name || self.examMenuData.exam_name.length < 1) {
        self.errorMessages.push(this.$t("validation.required_field").replace(":NAME", self.$t("exam.name")));
        self.scrollToTop();
        return false;
      }

      // Geçme notu kontrolü
      if (self.examMenuData.has_exam_pass_grade) {
        if (self.examMenuData.passmark == null || +self.examMenuData.passmark < 1) {
          self.errorMessages.push(this.$t("validation.required_field").replace(":NAME", self.$t("exam.passmark")));
          self.scrollToTop();
          return false;
        }
      }

      // Geçme notu YALNIZCA sınırsız haklı sınavlarda uygulanır ve 0-100
      // aralığında TAM SAYI olmalı. Sınırlı hakta backend passmark'ı 0
      // kaydettiği için değer doğrulanmaz (menü de alanı 0'a kilitler).
      if (self.examMenuData.attempt_limit === null) {
        const rawPassmark = self.examMenuData.passmark;
        const passmark = Number(rawPassmark);
        if (rawPassmark === '' || rawPassmark == null || !Number.isInteger(passmark)
            || passmark < 0 || passmark > 100) {
          self.errorMessages.push(self.$t("general.passmark_invalid"));
          self.scrollToTop();
          return false;
        }
      }

      // Sınav süresi kontrolü
      if (self.examMenuData.duration == null || +self.examMenuData.duration < 1) {
        self.errorMessages.push(this.$t("validation.required_field").replace(":NAME", self.$t("exam.duration")));
        self.scrollToTop();
        return false;
      }

      // Sınav hakkı kontrolü. `null` sınırsız demek ve geçerlidir; aksi halde
      // 1 ve üzeri TAM sayı olmalı — backend 0, negatif ve ondalıklı değerleri
      // reddediyor.
      const attemptLimit = self.examMenuData.attempt_limit;
      if (attemptLimit !== null) {
        const parsedAttemptLimit = Number(attemptLimit);
        if (!Number.isInteger(parsedAttemptLimit) || parsedAttemptLimit < 1) {
          self.errorMessages.push(self.$t("general.attempt_limit_invalid"));
          self.scrollToTop();
          return false;
        }
      }

      //Sınav Şıkları kontrol
      let hasError = myQuestions.some((question, questionIndex) => {

        let isCorrectCount = 0;
        let hasNullName = false;
        let hasNullMedia = false;

        if (question.text === '') {
          //editor alanındaki sınav sorusu
          self.errorMessages.push(self.$t("validation.required_field").replace(":NAME", self.$t("question.attributes.text")));
          self.scrollToTop();
          return true
        }

        if (self.examMenuData.every_question_has_score) {
          //sidebar da (Her sorunun bir puanı olsun) seçili ise , her sorunun belli bir puanı olacak
          if (question.questionScore == null || question.questionScore < 1) {
            self.errorMessages.push(this.$t("validation.required_field").replace(":NAME", self.$t("exam.questionScore_X")));
            self.scrollToTop();
            return true
          }
        }

        if (self.examMenuData.every_question_has_time_limit) {
          //sidebar da (Her sorunun bir süre sınırı olsun ) seçili ise , her sorunun belli bir süresi olacak
          if (question.questionDuration == null || question.questionDuration < 1) {
            self.errorMessages.push(this.$t("validation.required_field").replace(":NAME", self.$t("exam.questionDuration")));
            self.scrollToTop();
            return true
          }
        }

        question.options.forEach(option => {
          //her sorunun Şıkları için kontrol yap
          if (self.isOptionNameEmpty(option)) hasNullName = true;
          if (option.is_correct) isCorrectCount++;
          if (typeof option.media === "undefined") hasNullMedia = true;
        });

        if (hasNullName && (question.type !== 4 && question.type !== 5)) {
          //boş şık kontrolü
          self.errorMessages.push(self.$t("validation.required_field").replace(":NAME", self.$t("question.attributes.option_name")));
          self.scrollToTop();
          return true;
        }

        if (isCorrectCount === 0) {
          //en az bir doğru cevap olmalı
          self.errorMessages.push(self.$t("question.required.true_count"));
          self.scrollToTop();
          return true;
        }

        if (question.type === 1 && isCorrectCount > 1) {
          //çoktan seçmeli, en fazla 1 doğru cevap olabilir
          self.errorMessages.push(self.$t('question.required.must_have_max_one_correct_answer'));
          self.scrollToTop()
          return true;
        }

        if (hasNullMedia && (question.type === 4 || question.type === 5)) {
          //media controlling
          self.errorMessages.push(self.$t("validation.required_field").replace(":NAME", self.$t("question.attributes.option_media")));
          self.scrollToTop();
          return true;
        }

      });

      if (hasError) {
        // şıklarda hata varsa
        self.scrollToTop();
        return false;
      }

      // Eğer tüm validasyonlar geçerse, myQuestions'ı da geri döndürebiliriz
      return myQuestions;
    },
    /**
     * Bos sik kontrolu. Iki sayfada FARKLI idi ve davranis MOD BAZINDA
     * aynen korunuyor:
     *   ekleme     : !option.name       -> null / undefined / '' hepsini yakalar
     *   duzenleme  : option.name === '' -> yalnizca bos string
     *
     * Duzenlemede secenekler API'den geliyor (`setQuestions`: name =
     * option.text) ve `null` gelebiliyor. Kontrolu katilastirmak, bugune
     * kadar kaydedilebilen sinavlarin kaydedilemez hale gelmesine yol
     * acabilir; gevsetmek ise ekleme tarafinda bos sik gecirir. Hangisinin
     * dogru oldugu urun karari, o yuzden birlestirmede karar VERILMEDI.
     */
    isOptionNameEmpty(option) {
      return this.isEditMode ? option.name === '' : !option.name;
    },
    buildFormData(myQuestions) {
      let self = this;
      let formData = new FormData();

      myQuestions.forEach((question, questionIndex) => {
        // id'ler YALNIZCA guncellemede gonderilir: backend mevcut soru/sik
        // kayitlarini bu id'lerle eslestiriyor. Olusturmada gonderilmesi
        // "su id'li kaydi guncelle" anlamina gelirdi.
        if (self.isEditMode) {
          formData.append(`questions[${questionIndex}][id]`, question.id);
        }
        formData.append(`questions[${questionIndex}][type]`, question.type);
        formData.append(`questions[${questionIndex}][text]`, question.text);
        formData.append(`questions[${questionIndex}][media]`, question.media);

        question.options.forEach((option, optionIndex) => {
          if (self.isEditMode) {
            formData.append(`questions[${questionIndex}][options][${optionIndex}][id]`, option.id);
          }
          formData.append(`questions[${questionIndex}][options][${optionIndex}][name]`, option.name);
          formData.append(`questions[${questionIndex}][options][${optionIndex}][is_correct]`, option.is_correct);
          formData.append(`questions[${questionIndex}][options][${optionIndex}][media]`, option.media ?? '');
        });
      });

      // Exam menü alanlarını ekleme
      if (self.isEditMode) {
        formData.append("id", self.examMenuData.id);
      }
      formData.append("name", self.examMenuData.exam_name);
      // Sinirli hakli sinavda gecme notu uygulanmaz: backend passmark'i 0
      // kaydediyor, 0 puan dahil her sonuc basarili sayilip bir hak tuketiyor.
      // Menu alani zaten 0'a kilitliyor; bu kural payload sinirinda da acik olsun.
      formData.append("passmark", self.examMenuData.attempt_limit === null ? self.examMenuData.passmark : 0);
      formData.append("duration", self.examMenuData.duration);
      formData.append("is_default", self.examMenuData.is_default ? 1 : 0);
      formData.append("is_mix_questions", self.examMenuData.is_mix_questions ? 1 : 0);
      formData.append("is_mix_answers", self.examMenuData.is_mix_answers ? 1 : 0);
      formData.append("show_right_answers", self.examMenuData.show_right_answers ? 1 : 0);
      formData.append("show_user_answers", self.examMenuData.show_user_answers ? 1 : 0);
      formData.append("show_result", self.examMenuData.show_result ? 1 : 0);
      formData.append("is_compulsory", self.examMenuData.is_compulsory ? 1 : 0);
      formData.append("pre_post", self.examMenuData.pre_post ? 1 : 0);

      //bu alanlar ayrıca BE'de de oluşturulmalı
      formData.append("has_exam_pass_grade", self.examMenuData.has_exam_pass_grade ? 1 : 0);
      formData.append("every_question_has_time_limit", self.examMenuData.every_question_has_time_limit ? 1 : 0);
      formData.append("every_question_has_score", self.examMenuData.every_question_has_score ? 1 : 0);
      formData.append("if_failed_from_exam", self.examMenuData.if_failed_from_exam);
      formData.append("if_exit_from_exam", self.examMenuData.if_exit_from_exam);

      // FormData her degeri string'e cevirdigi icin sinirsiz hak, backend'in
      // null'a cevirdigi 'null' literali olarak gonderiliyor. Deger buraya
      // gelmeden once validateExamData'da dogrulandi.
      formData.append(
          "attempt_limit",
          self.examMenuData.attempt_limit === null ? 'null' : String(Number(self.examMenuData.attempt_limit))
      );

      return formData;
    },
    filterResult() {
      this.$store.dispatch(_MODULE_NAME + "/" + GET_ITEM, {
        url: BASE_URL + "/" + this.$route.params.id,
      }).then((response) => {
        this.exam = response.data;
        //prepost active ise dom mudahalesi ile değiştirilemesin
        this.isPrePostActive = this.exam?.pre_post === 1
        this.setQuestions();
        this.setExamMenuData()
      })
    },
    setQuestions() {
      let self = this;
      let questions = [];
      if (typeof self.exam.questions !== "undefined") {
        self.exam.questions.forEach(question => {
          let options = [];
          question.options.forEach(option => {
            options.push({
              id: option.id,
              name: option.text,
              is_correct: (option.is_correct === 1),
              media: option.media,
            })
          });
          questions.push({
            id: question.id,
            type: question.question_type_id,
            text: question.text,
            media: question.media,
            options: options,
            preview: question.question_type_id === 3 || question.question_type_id === 5 ? '<div class="file-info"><img src="' + question.question_media + '" alt=""></div>' : null,
            audioPreview: question.question_type_id === 7 ? '<div class="file-info"><div>' + this.$t('general.audio_file_name') + ': <span>' + question.media + '</span></div></div>' : null,
            videoPreview: question.question_type_id === 8 ? '<div class="file-info"><div>' + this.$t('general.video_file_name') + ': <span>' + question.media + '</span></div></div>' : null,
            previewReply: [],
            //questionScore: null, Be den gelince bağla
            //questionDuration: null
          });
        });
      }

      this.questions = questions;
    },
    setExamMenuData() {
      let exam = this.exam;

      this.examMenuData = {
        exam_name: exam.name || '',
        passmark: exam.passmark ?? 50,
        if_failed_from_exam: 'retry',
        if_exit_from_exam: 'continue',
        duration: exam.duration ?? 20,

        show_right_answers: exam.show_right_answers === 1,
        show_user_answers: exam.show_user_answers === 1,
        is_mix_questions: exam.is_mix_questions === 1,
        is_mix_answers: exam.is_mix_answers === 1,
        show_result: exam.show_result === 1,
        is_compulsory: exam.is_compulsory === 1,
        pre_post: exam.pre_post === 1,

        has_exam_pass_grade: false,
        every_question_has_time_limit: false,
        every_question_has_score: false,

        // `null` BILEREK oldugu gibi gecirilyor: sinirsiz hak demek.
        // Alan hic gelmezse (attempt_limit'i henuz dondurmeyen bir backend)
        // ExamPropertiesMenu bunu sinirsiza cevirir — boylece o kaydin gecme
        // notu korunur, sinirli hakka cekip passmark'i sifirlamaz.
        attempt_limit: exam.attempt_limit,
      };
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    setActiveTab(index) {
      this.activeTab = index;
      // #userAddOptions yalnizca ekleme modunda render ediliyor. Su an bu
      // metodu cagiran uc yer (excel import, anzera, onCancelled) de
      // ekleme moduna ozgu; guard ileride yeniden kullanilirsa patlamayi
      // engelliyor.
      if (this.isEditMode) return;
      UIkit.switcher("#userAddOptions").show(index);
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    // Olusturma basarisi saveForm().then() icinde ele alinir; bu watcher
    // SADECE duzenleme icin. Gate SART: exam.module hem CREATE_ITEM hem
    // UPDATE_ITEM sonrasi SET_SUCCESS=true yaziyor (satir 123 ve 155).
    // Kosulsuz birakilsa ekleme sonrasi da tetiklenir, `filterResult()`
    // id'siz calisip `/exam/undefined` istegi atar ve ikinci bir
    // yonlendirme yapardi.
    success: function (val) {
      if (val && this.isEditMode) {
        this.successMessage = this.$t("general.successfully_updated");
        this.filterResult();
        this.$router.push({ name: "company.exams.list" });
      }
    },
    // Add-demo'da bu watcher `errors` adiyla yazilmisti; boyle bir computed
    // olmadigi icin store hatalari ekleme sayfasinda hic gorunmuyordu.
    error: function (val) {
      if (val) {
        this.scrollToTop();
        this.errorMessages.push(val);
      }
    },
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
  },
  mounted() {
    if (this.isEditMode) {
      this.filterResult();
    }
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 5000);
  },
};
</script>
<style scoped>
.prepost-disable-all-questions {
  pointer-events: none;
  opacity: 0.5;
}

.prepost-message-disable-text {
  color: #bc0f0f;
  font-weight: bold;
  font-size: 14px;
}

.selected_questions {
  color: #ae71ff;
  border: 1px solid #eaeaea;
  display: block;
  font-size: 13px;
  line-height: 33px;
  padding: 1px 7px;
  border-radius: 8px;
}

.loading-bar {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 999;
  background: rgba(238, 238, 238, 0.5);
  display: flex;
  justify-content: center;
  align-items: center
}
</style>
